import React, { Component } from 'react';

import LoanApprovalLeads from './OptimizedAllLeadsEv.container'

class LatestDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leadsViewState: "Advance"
        }
    }


    render() {
        console.log("vallaa")
        const { allStatus, admin, newDataBackground, pageState } = this.props;
        return (
            <div className="full-height">
                <div className="container-fluid full-height">
                    <div className="row form-group">

                    </div>
                    <div className="row full-height">
                        {this.state.leadsViewState == "Advance" ?
                            <LoanApprovalLeads
                                allStatus={allStatus}
                                admin={admin}
                                newDataBackground={newDataBackground}
                                leadsViewState={this.state.leadsViewState}
                                leadChangeHandler={this.leadChangeHandler.bind(this)}
                                pageState={pageState}
                            />
                            : null}
                    </div>
                </div>
            </div>
        )
    }

    leadChangeHandler(e) {
        this.setState({
            leadsViewState: e.target.value
        })
    }
}

export default LatestDoc;